import { useEvaluateCurrentStatus } from '@common/projectHooks';
import { BaseColor, theme } from '@prophecy/theme';
import { Text, Badges, Stack } from '@prophecy/ui-v3';
import { lowerFirst } from 'lodash-es';

export const StatusSection = ({ currentProjectStatus }: { currentProjectStatus: string }) => {
  const projectStatus = useEvaluateCurrentStatus(currentProjectStatus);
  return (
    <Stack gap={theme.spaces.x20}>
      <Text level='sm' weight={theme.fontWeight.medium} tone={theme.colors.gray900}>
        Status
      </Text>
      <Badges tone={lowerFirst(projectStatus?.colour) as BaseColor} size='s'>
        {projectStatus?.entryName}
      </Badges>
    </Stack>
  );
};
